import { createSelector } from 'reselect';
import { getSelectedOrganization } from 'src/react/selectedWidget/selectors/getSelectedOrganization';
import { Organization } from 'src/types/entities/Organization';
import { UserRole } from 'src/types/values/UserRole';

export const getViewerMode = createSelector(
    [getSelectedOrganization],
    (organization: Organization) => organization.permission.userRole === UserRole.Viewer);
